import request from "@/../utils/request.js";
async function GetSurveyOptionInfo(guid){
    const result= {
        status: false,
        msg: "",
        data:""
    }
    try {
        var tmpData = {guid:guid}
        const res = await axiosRequest("/PortalAction/GetSurveyOptionInfo","post",tmpData);
        console.log(res.status);
        if(res.status && res.status){
            result.status = res.status;
            result.msg = res.msg;
            result.data = res.data;
        }else if(res.status === 401 ){
            result.status = false;
            result.msg = "無法取得資料，請重新整理後再試試";
            result.data = "";
        } else{
            result.status = false;
            result.msg = "載入失敗："+res.msg;
            result.data = "";
        }        
        console.log(result);
        return result;        
    } catch (error) {
        alert(error);
    }
}
async function GetSurveyTitleInfo(guid){
    const result= {
        status: false,
        msg: "",
        data:""
    }
    try {
        var tmpData = {guid:guid}
        const res = await axiosRequest("/PortalAction/GetSurveyTitleInfo","post",tmpData);
        console.log(res.status);
        if(res.status && res.status){
            result.status = res.status;
            result.msg = res.msg;
            result.data = res.data;
        }else if(res.status === 401 ){
            result.status = false;
            result.msg = "無法取得資料，請重新整理後再試試";
            result.data = "";
        } else{
            result.status = false;
            result.msg = "載入失敗："+res.msg;
            result.data = "";
        }        
        console.log(result);
        return result;        
    } catch (error) {
        alert(error);
    }
}
async function setSurveyOptionAnsToTxtByJson(jsonAns ){
    const result= {
        status: false,
        msg: "",
        data:""
    }
    try {
        var tmpData = {jsonAns:jsonAns };
        const res = await axiosRequest("/PortalAction/SetSurveyOptionAnsToTxtByJson","post",tmpData);
        console.log(res.status);
        if(res.status && res.status){
            result.status = res.status;
            result.msg = res.msg;
            result.data = res.data;
        }else if(res.status === 401 ){
            result.status = false;
            result.msg = "無法取得資料，請重新整理後再試試";
            result.data = "";
        } else{
            result.status = false;
            result.msg = "載入失敗："+res.msg;
            result.data = "";
        }        
        console.log(result);
        return result;        
    } catch (error) {
        alert(error);
    }
}
async function setSurveyOptionAnsByJson(jsonAns ){
    const result= {
        status: false,
        msg: "",
        data:""
    }
    try {
        var tmpData = {jsonAns:jsonAns };
        const res = await axiosRequest("/PortalAction/SetSurveyOptionAnsByJson","post",tmpData);
        console.log(res.status);
        if(res.status && res.status){
            result.status = res.status;
            result.msg = res.msg;
            result.data = res.data;
        }else if(res.status === 401 ){
            result.status = false;
            result.msg = "無法取得資料，請重新整理後再試試";
            result.data = "";
        } else{
            result.status = false;
            result.msg = "載入失敗："+res.msg;
            result.data = "";
        }        
        console.log(result);
        return result;        
    } catch (error) {
        alert(error);
    }
}
async function setSurveyOptionAns(USurveyMainGuid, Question, Ans, Remark, SurveyUser ){
    const result= {
        status: false,
        msg: "",
        data:""
    }
    try {
        var tmpData = {USurveyMainGuid:USurveyMainGuid, Question:Question, Ans:Ans, Remark:Remark, SurveyUser:SurveyUser };
        const res = await axiosRequest("/PortalAction/SetSurveyOptionAns","post",tmpData);
        console.log(res.status);
        if(res.status && res.status){
            result.status = res.status;
            result.msg = res.msg;
            result.data = res.data;
        }else if(res.status === 401 ){
            result.status = false;
            result.msg = "無法取得資料，請重新整理後再試試";
            result.data = "";
        } else{
            result.status = false;
            result.msg = "載入失敗："+res.msg;
            result.data = "";
        }        
        console.log(result);
        return result;        
    } catch (error) {
        alert(error);
    }
}
async function getSurveyMainInfoByEnable(guid){
    const result= {
        status: false,
        msg: "",
        data:""
    }
    try {
        var tmpData = {guid:guid}
        const res = await axiosRequest("/PortalAction/GetSurveyMainInfoByEnable","post",tmpData);
        console.log(res.status);
        if(res.status && res.status){
            result.status = res.status;
            result.msg = res.msg;
            result.data = res.data;
        }else if(res.status === 401 ){
            result.status = false;
            result.msg = "無法取得資料，請重新整理後再試試";
            result.data = "";
        } else{
            result.status = false;
            result.msg = "▌"+res.msg;
            result.data = "";
        }        
        console.log(result);
        return result;        
    } catch (error) {
        alert(error);
    }
}
function axiosRequest(url,method,data){
    return request({
        url:url,
        method:method,
        data:data
    })
}
function setJsonDateDecode(data){
    var JsonObject = JSON.parse(data);
    for(let idx in JsonObject){
        let tmpObj = (JsonObject[idx]);
        for(let idx2 in tmpObj){
            let tmpStr = tmpObj[idx2]+"";
            let tmpDecodeStr =decodeURIComponent(atob(tmpStr));
            //console.log(tmpStr,tmpDecodeStr);
            JsonObject[idx][idx2] = tmpDecodeStr;
        }
    }
    return JsonObject;
}

function setToyyyymmdd(d) {
    let year = d.getFullYear();
    let month = ("0" + (d.getMonth() + 1)).slice(-2); // Month is zero-based
    let day = ("0" + d.getDate()).slice(-2);
    let hour = ("0" + d.getHours()).slice(-2);
    let minute = ("0" + d.getMinutes()).slice(-2);
    let second = ("0" + d.getSeconds()).slice(-2);
    return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
}

function setDateStrToEn(tmpDate) {
    let arr =tmpDate.split(' ');
    let now =new Date(arr[0]);
    const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    const formattedDate = now.getDate() + '-' + months[now.getMonth()] + '-' + now.getFullYear();
    console.log(formattedDate);
    return formattedDate;
}

function setDateStrToyymmdd(tmpDate) {
    let arr =tmpDate.split(' ');
    let d =new Date(arr[0]);
    let year = d.getFullYear();
    let yy = (year+"").substr(-2, 2);
    let mm = ("0" + (d.getMonth() + 1)).slice(-2); // Month is zero-based
    let dd = ("0" + d.getDate()).slice(-2);
    return yy + "/" + mm + "/" + dd ;
}

function roundTo(number, decimalPlaces) {
    const factor = 10 ** decimalPlaces;
    return Math.round(number * factor) / factor;
}


function getCookie(cname)
{
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i=0; i<ca.length; i++) 
  {
    var c = ca[i].trim();
    if (c.indexOf(name)==0) return c.substring(name.length,c.length);
  }
  return "";
}

function setCookie(cname,cvalue,exdays)
{
  var d = new Date();
  d.setTime(d.getTime()+(exdays*24*60*60*1000));
  var expires = "expires="+d.toGMTString();
  document.cookie = cname + "=" + cvalue + "; " + expires;
}

export {setSurveyOptionAnsToTxtByJson,setJsonDateDecode,setSurveyOptionAnsByJson,setSurveyOptionAns,setToyyyymmdd,setDateStrToyymmdd,setDateStrToEn,roundTo,setCookie,getCookie,axiosRequest,getSurveyMainInfoByEnable,GetSurveyTitleInfo,GetSurveyOptionInfo}